import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "21",
  viewBox: "0 0 16 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.4987 6.06329H9.4987C10.2059 6.06329 10.8842 6.34424 11.3843 6.84434C11.8844 7.34444 12.1654 8.02272 12.1654 8.72996V14.73C12.1654 15.0394 12.0424 15.3361 11.8237 15.5549C11.6049 15.7737 11.3081 15.8966 10.9987 15.8966H2.9987C2.29145 15.8966 1.61318 15.6157 1.11308 15.1156C0.612983 14.6155 0.332031 13.9372 0.332031 13.23V7.22996C0.332031 6.92054 0.454948 6.62379 0.67374 6.405C0.892532 6.18621 1.18928 6.06329 1.4987 6.06329ZM1.66536 7.39663H9.4987C9.85232 7.39663 10.1915 7.5371 10.4415 7.78715C10.6916 8.0372 10.832 8.37634 10.832 8.72996V14.5633H2.9987C2.64508 14.5633 2.30594 14.4228 2.05589 14.1728C1.80584 13.9227 1.66536 13.5836 1.66536 13.23V7.39663Z",
      fill: "#A466FC"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.3334 7.40335C15.539 7.52263 15.6655 7.74231 15.6655 7.97996V13.98C15.6655 14.2176 15.539 14.4373 15.3334 14.5566C15.1279 14.6758 14.8744 14.6767 14.6681 14.5588L11.1681 12.5588C10.8484 12.3761 10.7373 11.9689 10.92 11.6492C11.1027 11.3295 11.5099 11.2185 11.8296 11.4011L14.3321 12.8312V9.12875L11.8296 10.5588C11.5099 10.7415 11.1027 10.6304 10.92 10.3107C10.7373 9.99104 10.8484 9.5838 11.1681 9.40113L14.6681 7.40113C14.8744 7.28323 15.1279 7.28407 15.3334 7.40335Z",
      fill: "#A466FC"
    }, null, -1)
  ])))
}
export default { render: render }